import { render, staticRenderFns } from "./PayoutsList.vue?vue&type=template&id=74821309"
import script from "./PayoutsList.vue?vue&type=script&lang=js"
export * from "./PayoutsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports